'use strict';

import { cn_building } from "../../model/cn_building";
import { cn_roof_slab } from "../../model/cn_roof_slab";
import { cn_slab } from "../../model/cn_slab";
import { cn_nomenclature } from "../cn_nomenclature";

//***********************************************************************************
//***********************************************************************************
//**** Build nomenclatures
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
/**
 * Build slab's types nomenclatures for the building
 * @param {cn_building} building
 * @returns {cn_nomenclature[]}
 */
export function cn_nomenclature_slabs_types(building) {
    const output = [];

    const slabs_tybes = building.get_slab_types();
    const max_material = Math.max(...slabs_tybes.map(it => it.layers.length));

    output.push(new cn_nomenclature('ID').withVirtual(true));
    output.push(new cn_nomenclature('ASSOCIATED_IDS').withVirtual(true));
    output.push(new cn_nomenclature('Nom'));
    output.push(new cn_nomenclature('Epaisseur').withNumberDefinition('m', 2));
    output.push(new cn_nomenclature('U').withNumberDefinition('W/m².K', 3));
    output.push(new cn_nomenclature('Nombre d\'occurence').withNumberDefinition('', 0));
    output.push(new cn_nomenclature('Surface totale').withNumberDefinition('m²', 2));

    for (let i = 1; i <= max_material; i++) {
        const nomenclatureName = new cn_nomenclature('Matériau ' + i);
        nomenclatureName.values = Array(slabs_tybes.length).fill('');
        output.push(nomenclatureName);
        const nomenclatureThickness = new cn_nomenclature('Épaisseur matériau ' + i).withNumberDefinition('cm', 2);
        nomenclatureThickness.values = Array(slabs_tybes.length).fill('');
        output.push(nomenclatureThickness);
    }

    const slabs = building.storeys.flatMap(st => st.slabs.map(slab => ({ slab, storey: st })))
        .concat(building.storeys.flatMap(st => st.upper_slabs.map(slab => ({ slab, storey: st }))))
        .concat(building.storeys.filter(st => st.roof).flatMap(st => st.roof.slabs.map(slab => ({ slab, storey: st }))));
    const slabs_ids_by_slab_type = new Map();
    slabs.forEach(slab_agg => {
        if (!slabs_ids_by_slab_type.has(slab_agg.slab.slab_type.ID)) {
            slabs_ids_by_slab_type.set(slab_agg.slab.slab_type.ID, [])
        }
        slabs_ids_by_slab_type.get(slab_agg.slab.slab_type.ID).push(slab_agg.slab.create_id_for_bbp(slab_agg.storey))
    });

    slabs_tybes.forEach((slab_type, i) => {
        let nomenclature_entry_index = 0;
        output[nomenclature_entry_index].values[i] = slab_type.ID;
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = slabs_ids_by_slab_type.get(slab_type.ID);
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = slab_type.get_label();
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = slab_type.thickness;
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = slab_type.get_U();
        nomenclature_entry_index++;
        const slabs_of_type = slabs.filter(sl => sl.slab.slab_type.ID === slab_type.ID).map(sl => sl.slab);
        output[nomenclature_entry_index].values[i] = slabs_of_type.length;
        nomenclature_entry_index++;
        output[nomenclature_entry_index].values[i] = slabs_of_type.reduce((agg, sl) => {
            if (sl.constructor == cn_slab)
                return agg + sl.build_polygon(0).get_area();
            else if (sl.constructor == cn_roof_slab) {
                const pgs = sl.build_3d_polygons(0);
                let x = agg;
                pgs.forEach(pg => x += pg.get_area());
                return x;
            }
            return 0;
        }, 0);

        nomenclature_entry_index++;
        slab_type.layers.forEach(layer => {
            output[nomenclature_entry_index].values[i] = layer.name;
            nomenclature_entry_index++;
            output[nomenclature_entry_index].values[i] = layer.thickness * 100;
            nomenclature_entry_index++;
        });
    });

    return output;
}
